export function getValidImgVariant(
	imgVariants: { l?: string; m?: string; s?: string } | null | undefined
) {
	if (!imgVariants) return null;

	return imgVariants.l || imgVariants.m || imgVariants.s || '';
}
